module.exports  = require('./lib/uniAxios');


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0